module.exports = __webpack_public_path__ + "static/media/6300.0bfe81e1.svg";